import { createReducer, on } from '@ngrx/store';
import { DEFAULT_DOCUMENT_TYPE_STATE } from '../constants';

import { DocumentTypes, DocumentTypeState } from '../types';
import { CONFIGURATION_DOCUMENT_TYPE_ACTIONS } from '../actions';

export const DOCUMENT_TYPES_REDUCER = createReducer<DocumentTypeState>(
  DEFAULT_DOCUMENT_TYPE_STATE,
  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.onLoadDocumentTypesSuccess,
    (state, { documentTypes }) => ({
      ...state,
      documentTypes: documentTypes,
      error: null,
      loading: false,
    }),
  ),

  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.onLoadAttributesSuccess,
    (state, { documentAttributes }) => ({
      ...state,
      attributes: documentAttributes,
    }),
  ),

  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.onLoadDocumentTypesFailure,
    (state, { error }) => ({
      ...state,
      documentTypes: DEFAULT_DOCUMENT_TYPE_STATE.documentTypes,
      documentTypesTableData:
        DEFAULT_DOCUMENT_TYPE_STATE.documentTypesTableData,
      error: error.message || 'Something went wrong',
      loading: false,
    }),
  ),

  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.onUpdateDocumentTypeSuccess,
    (state: DocumentTypeState, { data }) => {
      const computedData = state.documentTypes.data.map((doc) =>
        doc.id === data.id ? { ...data } : doc,
      );
      const documentTypes: DocumentTypes = {
        ...state.documentTypes,
        data: computedData,
      };
      return {
        ...state,
        documentTypes: documentTypes,
      };
    },
  ),

  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.onDeleteDocumentTypeSuccess,
    (state: DocumentTypeState, { documentId }) => {
      const computeData = state.documentTypes.data.filter(
        (doc) => doc.id !== documentId,
      );
      const documentTypes: DocumentTypes = {
        ...state.documentTypes,
        data: [...computeData],
        total: state.documentTypes.total - 1,
      };
      return {
        ...state,
        documentTypes: documentTypes,
      };
    },
  ),

  on(
    CONFIGURATION_DOCUMENT_TYPE_ACTIONS.setDocumentTypesTableData,
    (state, { tableData }) => ({
      ...state,
      documentTypesTableData: tableData,
    }),
  ),
);
